import { render, staticRenderFns } from "./UsersWholeStatistic.vue?vue&type=template&id=2eeabb4e&"
import script from "./UsersWholeStatistic.vue?vue&type=script&lang=js&"
export * from "./UsersWholeStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports